import { useEffect, useState } from "react";
import { UserService } from "../../Services/User.service";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { Dropdown, Form } from "react-bootstrap";
import TokenService from "../../Services/Token.service";
const US_STATES = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California",
    "Colorado", "Connecticut", "Delaware", "Florida", "Georgia",
    "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas",
    "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts",
    "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana",
    "Nebraska", "Nevada", "New Hampshire", "New Jersey",
    "New Mexico", "New York", "North Carolina", "North Dakota",
    "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
    "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah",
    "Vermont", "Virginia", "Washington", "West Virginia",
    "Wisconsin", "Wyoming"
];

const formatPhone = (value) => {
    if (!value) return value;

    // Remove all non-digits
    let digits = value.replace(/\D/g, "");

    // Limit: 1 digit country code + 10-digit phone number = 11 digits
    digits = digits.slice(0, 11);

    // Country code: only FIRST digit
    const country = digits.slice(0, 1);
    const rest = digits.slice(1);

    let formatted = `+${country}`;

    if (rest.length > 0) {
        formatted += ` (${rest.slice(0, 3)}`;
    }
    if (rest.length >= 3) {
        formatted += `) ${rest.slice(3, 6)}`;
    }
    if (rest.length >= 6) {
        formatted += `-${rest.slice(6, 10)}`;
    }

    return formatted;
};

const RequestorDeliveryAddress = ({ userData, setToastMessage, setToastVariant, setShowToast, setLoading}) => {
    const deliveryAddress = userData?.addresses?.find(
        (addr) => addr.type === "delivery"
    );
    useEffect(() => {
        console.log(userData.addresses);
        console.log(deliveryAddress);
    }, [userData.addresses]);

      const formik = useFormik({

        enableReinitialize: true,
        initialValues: {
            address_1: deliveryAddress?.address_line_1 || "",
            address_2: deliveryAddress?.address_line_2 || "",
            address_3: deliveryAddress?.address_line_3 || "",
            city: deliveryAddress?.city || "",
            state: deliveryAddress?.state || "",
            postal_code: deliveryAddress?.postal_code || "",
            office_number: deliveryAddress?.office_number
            ? formatPhone(deliveryAddress.office_number)
            : "",
        },

        validationSchema: Yup.object({
            address_1: Yup.string().required("User address is required"),
            address_2: Yup.string().required("User address is required"),
            address_3: Yup.string(), // optional
            city: Yup.string().required("City is required"),
            state: Yup.string().required("State is required"),
            postal_code: Yup.string()
                .matches(/^\d{5}$/, "Enter a valid 5-digit postal code")
                .required("Postal code is required"),
            office_number: Yup.string()
                .required("Direct Office number is required"),
        }),

        onSubmit: async (values) => {
            setLoading(true);

            const payload = {
                user_id: TokenService.getUserId(),        
                address_1: values.address_1,
                address_2: values.address_2,
                address_3: values.address_3,
                city: values.city,
                state: values.state,
                postal_code: values.postal_code,
                office_number: values.office_number.replace(/\D/g, ""),
            };

            try {
                const res = await UserService.saveDeliveryAddress(payload);

                if (res.success) {
                    setShowToast(true);
                    setToastMessage(res.message);
                    setToastVariant("success");
                } else {
                    // API FAILED → Set Formik field errors
                    if (typeof res.message === "object") {
                        const apiErrors = {};

                        Object.keys(res.message).forEach(key => {
                            apiErrors[key] = res.message[key][0]; // take first message
                        });

                        formik.setErrors(apiErrors); 
                    }

                    setShowToast(true);
                    setToastMessage("Please fix the errors below");
                    setToastVariant("error");
                }

            } catch (err) {
                setShowToast(true);
                setToastMessage("Something went wrong!");
                setToastVariant("error");
            } finally {
                setLoading(false);
            }


        }
    });
    const [stateSearch, setStateSearch] = useState("");

    const filteredStates = US_STATES.filter((s) =>
        s.toLowerCase().includes(stateSearch.toLowerCase())
    );
    return (<div className="el-bg-table el-super-admin mt-3">
        <h3>Delivery Address for samples</h3>
        <p>Please share the exact address you’d like included for sample delivery within your campus.</p>
         <form onSubmit={formik.handleSubmit} className="mt-4">
                <div className="row">

                    {/* Address 1 */}
                    <div className="col-6 mb-0">
                        <label className="form-label">Address 1<span className="text-red">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Address 1"
                            {...formik.getFieldProps("address_1")}
                        />
                        {formik.touched.address_1 && formik.errors.address_1 && (
                            <div  className="text-danger" >
                                {formik.errors.address_1}
                            </div>
                        )}
                    </div>

                    {/* Address 2 */}
                    <div className="col-6 mb-0">
                        <label className="form-label">Address 2<span className="text-red">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Address 2"
                            {...formik.getFieldProps("address_2")}
                        />
                        {formik.touched.address_2 && formik.errors.address_2 && (
                            <div  className="text-danger" >
                              {formik.errors.address_2}
                            </div>
                        )}
                    </div>

                    {/* Address 3 (optional) */}
                    <div className="col-6 mb-0">
                        <label className="form-label">Address 3</label>
                        <input
                            type="text"
                            className="form-control"
                            {...formik.getFieldProps("address_3")}
                        />
                    </div>

                    {/* City */}
                    <div className="col-6 mb-0">
                        <label className="form-label">City<span className="text-red">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter City Name"

                            {...formik.getFieldProps("city")}
                        />
                        {formik.touched.city && formik.errors.city && (
                            <div  className="text-danger" >
                                {formik.errors.city}
                            </div>
                        )}
                    </div>

                    {/* State */}
                    <div className="col-6 mb-0">
                        <label className="form-label">State</label>
                         <Dropdown className="w-100">
                            <Dropdown.Toggle
                                variant="light"
                                className="w-100 text-start form-control"
                            >
                                {formik.values.state || "Select State"}
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="w-100" style={{ maxHeight: "250px", overflowY: "auto" }}>
                                
                                {/* Search Box */}
                                <div className="px-2 py-2">
                                    <Form.Control
                                        type="text"
                                        placeholder="Search state..."
                                        value={stateSearch}
                                        onChange={(e) => setStateSearch(e.target.value)}
                                    />
                                </div>

                                <Dropdown.Divider />

                                {/* List items */}
                                {filteredStates.length > 0 ? (
                                    filteredStates.map((s) => (
                                        <Dropdown.Item
                                            key={s}
                                            onClick={() => formik.setFieldValue("state", s)}
                                        >
                                            {s}
                                        </Dropdown.Item>
                                    ))
                                ) : (
                                    <p className="px-3 text-muted">No results</p>
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                        {formik.touched.state && formik.errors.state && (
                            <div  className="text-danger" >
                               {formik.errors.state}
                            </div>
                        )}
                    </div>

                    {/* Postal Code */}
                    <div className="col-6 mb-0">
                        <label className="form-label">Postal Code<span className="text-red">*</span></label>
                        <input
                            type="text"
                            maxLength="5"
                            className="form-control"
                            placeholder="Enter Postal Code"

                            {...formik.getFieldProps("postal_code")}
                        />
                        {formik.touched.postal_code && formik.errors.postal_code && (
                            <div  className="text-danger" >
                            <p className="text-danger">{formik.errors.postal_code}</p>
                            </div>
                        )}
                    </div>

                    {/* Office Number */}
                    <div className="col-6 mb-0">
                        <label className="form-label">Direct Office Number<span className="text-red">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            value={formik.values.office_number}
                            placeholder="Enter Direct Offiece Number"
                            onKeyDown={(e) => {
                                if (e.key === "Backspace" || e.key === "Delete") {
                                    formik.setFieldValue(
                                        "office_number",
                                        formik.values.office_number.replace(/\D/g, "").slice(0, 11)
                                    );
                                }
                            }}
                            onChange={(e) =>
                                formik.setFieldValue(
                                    "office_number",
                                    formatPhone(e.target.value)
                                )
                            }
                        />
                        {formik.touched.office_number && formik.errors.office_number && (
                            <div  className="text-danger" >
                                {formik.errors.office_number}
                            </div>
                        )}
                    </div>

                </div>

                <button className="el-main-button mt-3" type="submit">
                    <span>{"Save Address"}</span>
                </button>
            </form>
        <div>
        </div>
    </div>);
};
export default RequestorDeliveryAddress;